import { HiExclamation } from 'react-icons/hi'

import { Alert, Box, Collapse, Icon } from '@chakra-ui/react'

interface EventSectionAlertIProps {
  shouldShow: boolean
  title: string
}

export const EventSectionAlert = ({
  title,
  shouldShow,
}: EventSectionAlertIProps) => {
  return (
    <Collapse in={shouldShow}>
      <Alert
        borderRadius='10px'
        color='red.600'
        fontSize='13px'
        mt='5px'
        status='error'
      >
        <Icon as={HiExclamation} boxSize='20px' mr='10px' />
        <Box fontWeight={400}>{title}</Box>
      </Alert>
    </Collapse>
  )
}
